import { CONFIG } from '../core/config';
import { ViewModel } from './view-model';

export class MediaItemDetails implements ViewModel {
  public readonly friendlyTypeNameSingular: string = 'Media Item Details';
  public readonly apiRoute: string = CONFIG.apiRoutes.mediaItemDetails;

  public mediaItemDetailsId: string;
  public name: string;
  public mediaType: MediaType;
  public attachedDate: string;
  public location: string;
  public comments: string;
  public tags: string;
  public fileLocation: string;
  public orgTreeNodeId: string;
  public fileExtension: string;
  public fileLinkAddress: string;
  public attachmentType: MediaAttachmentType = MediaAttachmentType.DataStorage;
  public showOnAssetHub: boolean;

  json() {
    return this;
  }

  loadFromJson(data) {
    this.mediaItemDetailsId = data.mediaItemDetailsId;
    this.name = data.name;
    this.mediaType = data.mediaType;
    this.attachedDate = data.attachedDate;
    this.location = data.location;
    this.comments = data.comments;
    this.tags = data.tags;
    this.fileLocation = data.fileLocation;
    this.orgTreeNodeId = data.orgTreeNodeId;
    this.fileExtension = data.fileExtension;
    this.fileLinkAddress = data.fileLinkAddress;
    this.attachmentType = data.attachmentType;
    this.showOnAssetHub = data.showOnAssetHub;
  }
}

export enum MediaType {
  Video = 1,
  Image = 2,
  Pdf = 3,
  Other = 4
}

export enum MediaAttachmentType {
  DataStorage = 1,
  FileLink = 2
}
